import { render, staticRenderFns } from "./UserChips.vue?vue&type=template&id=460e1e56"
import script from "./UserChips.vue?vue&type=script&lang=js"
export * from "./UserChips.vue?vue&type=script&lang=js"
import style0 from "./UserChips.vue?vue&type=style&index=0&id=460e1e56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports